export default "__VITE_ASSET__fea0c931__"